import script from "./agentDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./agentDashboard.vue?vue&type=script&setup=true&lang=js"

import "./agentDashboard.vue?vue&type=style&index=0&id=4282891a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4282891a"]])

export default __exports__